import { useQuery } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import { useCheckoutParams, CheckoutOptions } from "./checkoutUtils";

const useCheckout = (pathname: string, options?: CheckoutOptions) => {
  const { get } = useAuthenticatedApiRequest();
  const { buildCheckoutUrl } = useCheckoutParams();

  return useQuery<string, Error, string>({
    queryKey: ["checkout", { pathname, options }],
    queryFn: async () => {
      const url = buildCheckoutUrl(pathname, options);
      const response = await get(url, {
        headersOpts: {
          Referrer: window.location.href,
        },
      });
      return response.json();
    },
    enabled: options?.enabled,
  });
};

export default useCheckout;
